<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 系列列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<el-input placeholder="系列名称" class="handle-input mr10" v-model="xilieName" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-circle-plus-outline" @click="create">创建系列</el-button>
			</div>
			<el-table :data="personList" style="width: 100%;margin-bottom: 20px;" border>
				<el-table-column prop="Name" label="系列名称" width="300" align="center">
				</el-table-column>
				<el-table-column prop="ParentName" label="类别名称" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
						<el-button type="text" icon="el-icon-delete" @click="deleteClass(scope.row)"
							style="color: #ff0000;">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>

			<!-- 编辑弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<!-- <el-form-item label="类别名称" prop="upResName">
						<el-select v-model="ruleForm.ParentId" clearable placeholder="请选择" @clear="handleClear"
							ref="selectUpResId">
							<el-option key="ParentId" :value="ruleForm.ParentId" :label="upResName">
							</el-option>
							<el-tree :data="treeList" :props="defaultProps" @node-click="handleNodeClick" />
						</el-select>
					</el-form-item> -->
					<el-form-item label="类别名称" prop="ParentId">
						<el-select v-model="ruleForm.ParentId" clearable placeholder="请选择类别名称">
							<el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="系列名称" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<!-- <el-form-item label="修改人" prop="UserId">
						<el-input v-model="ruleForm.UserId" :disabled="!isdisabled"></el-input>
					</el-form-item> -->
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>
			
			<!-- 创建弹出框 -->
			<el-dialog :title="title2" v-model="editVisible2" width="30%">
				<el-form label-width="100px" ref="saveForm" :model="saveForm" :rules="rules2">
					<!-- <el-form-item label="类别名称" prop="ParentId">
						<el-select v-model="saveForm.ParentId" clearable placeholder="请选择" @clear="handleClear"
							ref="selectUpResId">
							<el-option key="ParentId" :value="saveForm.ParentId" :label="upResName">
							</el-option>
							<el-tree :data="treeList" :props="defaultProps" @node-click="handleNodeClick"
								 />
						</el-select>
					</el-form-item> -->
					<el-form-item label="类别名称" prop="ParentId">
						<el-select v-model="saveForm.ParentId" clearable placeholder="请选择类别名称">
							<el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="系列名称" prop="Name">
						<el-input v-model="saveForm.Name"></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible2 = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit2('saveForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {

		data() {
			return {
				classList:[],
				ishow:true,
				personList: [],
				xilieName: '', //系列名称
				UserId: localStorage.getItem('Id'),
				UserName: localStorage.getItem('ms_username'),
				token: localStorage.getItem('access_token'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				treeList: [],
				editVisible: false,
				editVisible2: false,
				title: '',
				title2: '',
				isdisabled: '',
				ruleForm: [],
				rules: {
					Name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					ParentId: [{
						required: true,
						message: '请输入类别名称',
						trigger: 'blur'
					}]
				},
				rules2: {
					Name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					ParentId: [{
						required: true,
						message: '请输入类别名称',
						trigger: 'blur'
					}]
				},
				upResName: '',
				saveForm: [],
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
			}
		},
		created() {
			this.getclass()
			this.getData()
		},
		methods: {
			//删除系列
			deleteClass(row) {
				
				
				this.$confirm('您确认是否要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
				
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteSeries?seriesId=" + row
							.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Data) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getData()
						} else {
							this.$message.error('该系列下有关联数据，无法删除!')
						}
					})
				
				
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
				
				
				// console.log(row)
				// axios({
				// 	method: 'get',
				// 	url: this.$store.state.pcurl + "GetCollectiblesStatistics?seriesId=" + row.Id,
				// 	headers: {
				// 		"Authorization": "bearer " + this.token
				// 	},
				// }).then((res) => {
				// 	console.log(res.data.Data)
				// 	if (res.data.Data == '') {
				// 		this.$confirm('该系列下没有已完成的商品数据, 是否继续?', '提示', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'success'
				// 		}).then(() => {
				
				// 			axios({
				// 				method: 'post',
				// 				url: this.$store.state.pcurl + "DeleteSeries?seriesId=" + row
				// 					.Id,
				// 				headers: {
				// 					"Authorization": "bearer " + this.token
				// 				},
				// 			}).then((res) => {
				// 				if (res.data.Message == '请求成功') {
				// 					this.$message({
				// 						type: 'success',
				// 						message: '删除成功!'
				// 					});
				// 					this.getData()
				// 				}
				// 			})
				
				// 		}).catch(() => {
				// 			this.$message({
				// 				type: 'info',
				// 				message: '已取消删除'
				// 			});
				// 		});
				// 	} else {
				// 		this.$confirm('该系列下有已完成的商品数据, 是否继续?', '提示', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'warning'
				// 		}).then(() => {
				
				// 			axios({
				// 				method: 'post',
				// 				url: this.$store.state.pcurl + "DeleteSeries?seriesId=" + row
				// 					.Id,
				// 				headers: {
				// 					"Authorization": "bearer " + this.token
				// 				},
				// 			}).then((res) => {
				// 				if (res.data.Message == '请求成功') {
				// 					this.$message({
				// 						type: 'success',
				// 						message: '删除成功!'
				// 					});
				// 					this.getData()
				// 				}
				// 			})
				
				// 		}).catch(() => {
				// 			this.$message({
				// 				type: 'info',
				// 				message: '已取消删除'
				// 			});
				// 		});
				// 	}
				// })
			},
			// 获取全部分类
			getclass(){
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCategories?name=" + '' + '&pageSize=99999999',
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res)=>{
					console.log(res.data.Data)
					this.classList = res.data.Data
				})
			},
			handleSearch(){
				this.getData()
			},
			handleNodeClick(data) {
				this.upResName = data.Name
				this.saveForm.ParentId = data.Id //创建的表单
				this.ruleForm.ParentId = data.Id //编辑的表单
			},
			handleClear() {
				// 将选择器的值置空
				this.upResName = ''
				this.saveForm.ParentId = ''
			},
			buildTree(arr, ParentId) {
				let tree = [];
				arr.map((item) => {
					if (item.ParentId === ParentId) {
						item.children = this.buildTree(arr, item.Id);
						tree.push(item);
					}
				});
				return tree;
			},
			getData() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeries?&pageSize=" + this.pageSize + '&pageIndex=' + pageIndex +'&name=' + this.xilieName,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						console.log(res.data.Data)
						this.personList = res.data.Data
						this.pageTotal = res.data.Count
						this.personList.forEach((x)=>{
							axios({
								method: 'get',
								url: this.$store.state.pcurl +
									"GetCategoryModel?categoryId=" + x.ParentId,
								headers: {
									Authorization: 'bearer ' + this.token
								}
							}).then((res) => {
								if(res.data.Data){
									x.ParentName = res.data.Data.Name
								}
							})
						})
					} else {
						this.$message.error('分类列表获取失败')
					}
				})
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//创建
			create() {
				this.title2 = '创建'
				this.saveForm = []
				this.editVisible2 = true
			},
			//编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeriesModel?seriesId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.ruleForm = res.data.Data
					this.editVisible = true
					
					axios({
						method: 'get',
						url: this.$store.state.pcurl +
							"GetCategoryModel?categoryId=" + this.ruleForm.ParentId,
						headers: {
							Authorization: 'bearer ' + this.token
						}
					}).then((res) => {
						if(!res.data.Data){
							this.ruleForm.ParentId = ''
						}
					})
					
				})
			},
			//创建保存
			saveEdit2(saveForm) {
				this.saveForm.UserId = this.UserId
				this.$refs[saveForm].validate((valid) => {
					if (valid) {
						axios({
							method: 'post',
							url: this.$store.state.pcurl + "AddSeries",
							data: qs.stringify(this.saveForm),
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								this.editVisible2 = false
								this.$message({
									message: '创建成功',
									type: 'success'
								})
								this.getData()
							} else {
								this.$message.error('创建失败');
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateSeries",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					})
				} else {
					this.editVisible = true
				}
			}
		}
	};
</script>

<style scoped>
	:deep(th){
		text-align: center;
	}
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
</style>


